import Routes from './routes'
import ThemeConfig from './theme'
import { useEffect, useState } from 'react'
import { SnackbarProvider } from 'notistack'
import NavigationScroll from './layout/NavigationScroll'
import CircularProgressScreen from './components/CircularProgress'
import { useNavigate, useLocation } from 'react-router-dom'
import axios from 'axios'
import { useDispatch } from 'react-redux'
import { getProfile } from './features/auth/redux/authAction' 


const App = () => {
    const dispatch = useDispatch()
  const [userInfo, setUserInfo] = useState(null)
  const [isLogged, setIsLogged] = useState(null)
  const [loading, setLoading] = useState(true)

  const navigate = useNavigate()
  const location = useLocation()

    useEffect(() => {
  if (window.top !== window.self) {
    window.top.location = window.self.location;
  }
}, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search)
    const authCode = urlParams.get('code')

    if (authCode) {
      axios.post(`${process.env.REACT_APP_SCHEMA_URL}/admin/auth/callback`,
        { code: authCode },
        { withCredentials: true }
      )
        .then(() => {
          return dispatch(getProfile())
        })
        .then((res) => {
          setUserInfo(res.data)
          setIsLogged(true)
        })
        .catch((error) => {
          console.error('Login failed or profile error', error)
          setIsLogged(false)
        })
        .finally(() => {
          navigate('/', { replace: true }) 
          setLoading(false)
        })
    } else {
         dispatch(getProfile())
        .then((res) => {
          setUserInfo(res.data)
          setIsLogged(true)
        })
        .catch((error) => {
          setIsLogged(false)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [])

  if (loading || isLogged === null) {
    return <CircularProgressScreen />
  }

  return (
    <ThemeConfig>
      <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <NavigationScroll>
          <Routes isLogged={isLogged} userInfo={userInfo} />
        </NavigationScroll>
      </SnackbarProvider>
    </ThemeConfig>
  )
}

export default App
